require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-finally-a-pretty-replacement-for-ri.json") })
        }
      }, "path---blog-finally-a-pretty-replacement-for-ri");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-finally-a-pretty-replacement-for-ri!./.cache/json/blog-finally-a-pretty-replacement-for-ri.json
// module id = 802
// module chunks = 231608221292675